import { useStore } from "@/store";

const createMiddlewareRestrictor = (byWhat) => {
  return ({ restrictList = [], allowList = [], redirectTo }) => {
    const middleware = (_, __, next) => {
      const store = useStore();
      const id = store.getters[byWhat];

      if (allowList.length) {
        if (allowList.includes(id)) {
          next();
        } else {
          next(redirectTo);
        }
      } else {
        if (restrictList.includes(id)) {
          next(redirectTo);
        } else {
          next();
        }
      }
    };

    return middleware;
  }
};

export const restrictByProjId = createMiddlewareRestrictor("projectId");

export const restrictByOrgId = createMiddlewareRestrictor("organizationId");

